<template>
  <div class="modal">
    <div class="backdrop" @click="close" />
    <div class="container flex justify-center items-center">
      <div class="content">
        <p class="close" @click="close">
          <i class="fas fa-times"></i>
        </p>
        <div class="content_modal">
          <div class="row">
            <p class="title">
              TERMOS E CONDIÇÕES PARA OS TOMADORES E INVESTIDORES
            </p>
          </div>
          <div class="p-4 md:mt-6">
            <p class="title">1. QUEM SOMOS</p>
            <p>
              1.1. Tutu Digital Tecnologia Ltda é uma plataforma online que
              permite a realização de investimentos e financiamentos de parte a
              parte (peer-to-peer lending), por meio da aproximação de
              investidores (“Investidor(es)”) e tomadores de empréstimos
              (“Tomador(es)” e, em conjunto com os Investidores, (“Usuários”),
              de modo que os primeiros possam atender a demanda de crédito dos
              segundos (“Plataforma Tutu”).
            </p>
            <p>
              1.2. A Plataforma Tutu não realiza as operações de empréstimo e/ou
              investimento diretamente, atuando como intermediadora e
              procuradora dos Usuários (i) na contratação de empréstimos perante
              a instituição financeira parceira em favor dos Tomadores, mediante
              investimento pelos Investidores e (ii) na aquisição de títulos de
              investimento (Certificados de Depósitos Bancários – CDBs ou
              Cédulas de Crédito Bancário – CCBs) pelos Investidores, sendo
              essas operações realizadas no âmbito do mercado de crédito.
            </p>
            <p>
              1.3 A Tutu Digital atua exclusivamente como intermediadora e
              procuradora, não sendo parte nas operações financeiras realizadas
              entre Tomadores, Investidores e instituições financeiras
              parceiras. Fica expressamente estabelecido que a Tutu Digital não
              assume qualquer responsabilidade solidária ou subsidiária pelas
              obrigações contratuais das partes envolvidas nas operações
              financeiras realizadas por meio da Plataforma Tutu.
            </p>
            <p>
              1.4. O Usuário deverá cumprir com os termos e condições da
              Plataforma Tutu e com os seguintes requisitos necessários para o
              estabelecimento da relação contratual (“Termos”):
            </p>
            <p>a) ser maior de 18 (dezoito) anos;</p>
            <p>b) residir em território brasileiro; e</p>
            <p>
              c) estar devidamente inscrito no Cadastro de Pessoas Físicas ou
              Cadastro Nacional de Pessoas Jurídicas do Ministério da Economia
              (CPF/ME ou CNPJ/ME).
            </p>
            <p>
              1.5. Para determinados investimentos na Plataforma Tutu, o
              Investidor deverá, eventualmente, (i) atender aos critérios para
              sua qualificação de investidor qualificado (ou profissional), nos
              termos da Resolução CVM nº 30 de 11 de maio de 2021; e (ii)
              atender aos critérios para sua qualificação de Investidor, como
              aos critérios de suitability (adequação de perfil) da Plataforma
              Tutu.
            </p>
            <p>
              Maiores informações estão disponibilizadas na página de acesso
              <a href="http://www.tutudigital.com.br/">www.tutudigital.com.br</a
              >, inclusive por meio do nosso FAQ disponível em
              <a href="https://www.tutudigital.com.br/investimento"
                >https://www.tutudigital.com.br/investimento</a
              >.
            </p>
            <p class="title">2. INTRODUÇÃO</p>
            <p>
              2.1. A TUTU DIGITAL TECNOLOGIA LTDA. ou à TD CORRESPONDENTE
              BANCÁRIO LTDA. (“Tutu”) poderá ser referida nestes Termos como
              &quot;nós&quot; e &quot;nosso&quot;. Os Usuários poderão ser
              referidos como “você”, seja como indivíduo ou em nome de uma
              entidade que preencha os critérios para Tomadores ou Investidores,
              estabelecidos nos itens 3 e 4 abaixo. Da mesma forma, as
              referências a “Serviços”, &quot;Sistemas&quot;,
              &quot;Plataforma&quot; ou “Site”, remetem a um dos serviços
              prestados por nós. As referências a &quot;você&quot; e
              &quot;seu&quot; remetem ao usuário da Plataforma,
            </p>
            <p>
              2.2. Caso você decida se tornar um Usuário da Plataforma Tutu como
              Tomador ou Investidor, será necessário o cumprimento destes
              Termos.
            </p>
            <p>
              2.3. Assim, pedimos a gentileza de que estes Termos sejam
              devidamente lidos e compreendidos, bem como nossos Termos e
              Condições de Uso e Política de Privacidade.
            </p>
            <p>
              2.4. Ao usar nossa Plataforma e os serviços prestados por meio
              dela ou de quaisquer outros sistemas fornecidos pela Plataforma
              Tutu, você deverá, necessariamente, confirmar que leu, entendeu e
              concordou com estes Termos, bem como com os Termos e Condições de
              Uso e com a Política de Privacidade (cada qual conforme alterada
              de tempos em tempos), assim como quando estiver agindo em nome de
              uma sociedade anônima, sociedade limitada, sociedade simples ou
              outra entidade separada. Se você não concorda com estes termos e
              condições, você deve parar de usar esta Plataforma imediatamente.
            </p>
            <p>
              2.5. Ao aceitar estes Termos, bem como os Termos e Condições de
              Uso e Política de Privacidade aplicáveis à Plataforma Tutu, você
              declara e garante que é maior de 18 (dezoito) anos e é responsável
              pelos atos realizados na Plataforma Tutu.
            </p>
            <p>
              2.6. Se você tiver menos de 18 (dezoito) anos de idade, você deve
              parar de usar a Plataforma Tutu imediatamente.
            </p>
            <p>
              2.7. Cada realização de empréstimo e investimento deve respeitar
              as condições de crédito e os termos do contrato celebrado entre
              Tomador e a instituição financeira parceira da Plataforma Tutu
              (&quot;Contrato de Empréstimo&quot;). O Contrato de Empréstimo é
              um acordo separado e é regido por termos e condições
              independentes, o qual poderá ser formalizado pela Tutu agindo por
              conta e ordem do Investidor, conforme previamente autorizado por
              meio da Plataforma.
            </p>
            <p>
              2.8. Nesse ponto, a Tutu tem poderes e capacidade de atuar em nome
              dos Investidores em relação aos empréstimos e investimentos, bem
              como para executar eventuais débitos decorrentes de inadimplemento
              destes Termos por parte dos Tomadores.
            </p>
            <p>
              2.9. Se você, ao atuar em nome de uma sociedade anônima, sociedade
              limitada, sociedade simples, MEI ou qualquer outra pessoa
              jurídica, utilizar esta Plataforma ou celebrar um Contrato de
              Empréstimo, deverá declarar e garantir que está devidamente
              autorizado e possui poderes para agir em nome da respectiva pessoa
              jurídica.
            </p>
            <p class="title">3. CADASTRO E MANUTENÇÃO DO TOMADOR</p>
            <p>
              3.1. Para ser um Tomador na Plataforma Tutu, você deve atender aos
              seguintes critérios:
            </p>
            <p>
              (a) possuir uma empresa devidamente cadastrada no Cadastro
              Nacional de Pessoas Jurídicas do Ministério da Economia (CNPJ/ME),
              que se encontre em plena atividade econômica há pelo menos 15
              (quinze) meses, bem como possua sede e representante legal com
              domicílio no país;
            </p>
            <p>
              (b) Indicar um endereço válido, devendo mantê-lo atualizado. Para
              tanto, a Plataforma Tutu poderá, a qualquer tempo, solicitar o
              envio de comprovante de endereço atual em nome da Tomadora.
              Eventuais citações, no âmbito de processos judiciais, direcionadas
              ao endereço informado presumir-se-ão válidas.
            </p>
            <p>
              (c) disponibilizar uma conta bancária para ser usada em suas
              movimentações financeiras relacionadas com a Plataforma Tutu;
            </p>
            <p>
              (d) a empresa Tomadora, seus diretores, administradores, sócios ou
              proprietários devem atender a critérios mínimos de risco de
              crédito e de prevenção a fraude, que incluem a obtenção de uma
              pontuação mínima de agências de referência de crédito, tais como
              Equifax ou Experian, de acordo com a cláusula 3.2 e 3.3 abaixo,
              com o que você, desde já, concorda.
            </p>
            <p>
              (e) registrar e apresentar detalhes de seu negócio para publicação
              no site
              <a href="http://www.tutudigital.com.br/">www.tutudigital.com.br</a
              >. Favor notar que alguns (mas não todos) desses detalhes serão
              divulgados para os Investidores, de acordo com a cláusula 5.1
              abaixo, com o que você, desde já, concorda.
            </p>
            <p>
              3.2. Como parte do processo de cadastro, vamos precisar confirmar
              a sua identidade e a da empresa, bem como as pessoas autorizadas a
              agir em seu nome. Nós vamos fazer isso usando agências de
              referência de crédito, tais como Equifax ou Experian. Caso seja
              necessário, podemos requisitar o envio de cópias de seus
              documentos de identificação, da empresa e seus representantes, bem
              como quaisquer outros que venham a ser necessários. Se os
              documentos de identificação não forem devidamente submetidos,
              infelizmente, você não poderá contratar empréstimos na Plataforma
              Tutu.
            </p>
            <p>
              3.3. Uma vez que você tiver se cadastrado e solicitado empréstimo
              na Plataforma Tutu, nós iremos analisar seu crédito e os
              procedimentos antifraude e de prevenção à lavagem de dinheiro,
              tanto em relação à empresa quanto a você enquanto proprietário,
              sócio ou diretor/administrador, usando agências de referência de
              crédito, tais como Equifax ou Experian. A Tutu usa suas próprias
              diretrizes e políticas na avaliação dos pedidos de Empréstimo, bem
              como as diretrizes e políticas da instituição financeira parceira.
            </p>
            <p>
              3.4. Você declara e garante à Plataforma Tutu que todas as
              informações fornecidas a nós no curso do processo de aplicação e
              empréstimo são verdadeiras e precisas em todos os aspectos. Você
              irá nos atualizar sobre a mudança de qualquer uma das informações
              já fornecidas.
            </p>
            <p>
              3.5. Você declara e garante ter nos revelado quaisquer
              circunstâncias que possam resultar na mudança de sua condição
              financeira ou do seu negócio (incluindo, sem limitar, quaisquer
              reclamações, passivos ocultos, litígios, arbitragem, processos
              judiciais, administrativos ou investigações).
            </p>
            <p>
              3.6. Você concorda em fornecer, o mais brevemente possível,
              informações e documentos completos para a Plataforma Tutu, caso
              você tome ciência ou suspeite que alguma das circunstâncias
              previstas na cláusula 3.5 ocorreram ou possam ocorrer. Além disso,
              você deverá fornecer à Plataforma Tutu as informações acerca de
              sua condição financeira, negócios e assuntos comerciais de tempos
              em tempos.
            </p>
            <p>
              3.7. Em caso de ciência de qualquer processo
              administrativo/judicial, atual ou futuro, da Receita Federal do
              Brasil ou de outra entidade pública contra você, você não poderá
              aceitar um empréstimo a menos que tenha prestado à Plataforma Tutu
              todas as informações acerca do processo e a Plataforma Tutu tenha
              acordado com o oferecê-lo.
            </p>
            <p>
              3.8. Outras informações também podem ser requisitadas, conforme
              disposto nos Termos e Condições de Uso, disponível no link
              <a href="http://www.tutudigital.com.br/">www.tutudigital.com.br</a
              >.
            </p>
            <p class="title">4. CADASTRO E MANUTENÇÃO DE INVESTIDOR</p>
            <p>
              4.1. Para se tornar um Investidor, você pode ser pessoa física ou
              jurídica.
            </p>
            <p>
              Investidor Pessoa Física deve atender aos seguintes critérios:
            </p>
            <p>(a) ser maior de 18 (dezoito) anos;</p>
            <p>(b) residir em território brasileiro;</p>
            <p>
              (c) estar devidamente inscrito no Cadastro de Pessoas Físicas
              (CPF/ME);
            </p>
            <p>
              (d) indicar uma conta bancária para fazer os aportes e resgates
              dos investimentos;
            </p>
            <p>
              (e) ao se cadastrar na Plataforma Tutu, abrir uma conta de
              pagamento (gerida por instituição de pagamento parceira da Tutu)
              para operacionalizar os investimentos;
            </p>
            <p>
              (f) No momento do cadastro e preenchimento das informações
              bancárias, a Tutu criará, automaticamente, uma Chave PIX vinculada
              à conta de titularidade do próprio Usuário na instituição de
              pagamento parceira.
            </p>
            <p>
              (g) A instituição de pagamento parceira é uma plataforma
              terceirizada, responsável pelo processamento dos pagamentos, ou
              seja, o gerenciamento e a divisão automática dos valores quando o
              pagamento é realizado.
            </p>
            <p>
              (h) Para a abertura, movimentação e encerramento da conta de
              pagamento, bem como para o cadastramento da Chave PIX e outros
              consentimentos necessários à utilização dos produtos e serviços da
              instituição de pagamento, a Tutu atuará como representante legal
              do Usuário, com poderes para assinar e realizar as operações
              financeiras associadas à sua conta.
            </p>
            <p>
              Investidor Pessoa Jurídica deve atender aos seguintes critérios:
            </p>
            <p>
              (a) possuir uma empresa devidamente cadastrada no Cadastro
              Nacional de Pessoas Jurídicas do Ministério da Economia (CNPJ/ME),
              que se encontre em plena atividade econômica, possua sede e
              representante legal com domicílio no país;
            </p>
            <p>
              (b) disponibilizar uma conta bancária para fazer os aportes e
              resgates dos investimentos;
            </p>
            <p>
              (c) ao se cadastrar na Plataforma Tutu, abrir uma conta de
              pagamento (gerida por instituição de pagamento parceira da Tutu)
              para operacionalizar os investimentos;
            </p>
            <p>
              (d) No momento do cadastro e preenchimento das informações
              bancárias, a Tutu criará, automaticamente, uma Chave PIX vinculada
              à conta de titularidade da empresa Usuária na instituição de
              pagamento parceira.
            </p>
            <p>
              (e) A instituição de pagamento parceira é uma plataforma
              terceirizada, responsável pelo processamento dos pagamentos, ou
              seja, o gerenciamento e a divisão automática dos valores quando o
              pagamento é realizado.
            </p>
            <p>
              (f) Para a abertura, movimentação e encerramento da conta de
              pagamento da empresa, bem como para o cadastramento da Chave PIX e
              outros consentimentos necessários à utilização dos produtos e
              serviços da instituição de pagamento, a Tutu atuará como
              representante legal da empresa Usuária, com poderes para assinar e
              realizar as operações financeiras associadas à conta da empresa.
            </p>
            <p>4.2. Atualização Cadastral do Investidor</p>
            <p>
              4.2.1. O Investidor compromete-se a manter seus dados cadastrais
              permanentemente atualizados perante a Tutu Digital, incluindo, mas
              não se limitando as informações de identificação, endereço, dados
              bancários, situação patrimonial e financeira, e demais informações
              necessárias para cumprimento das obrigações regulatórias.
            </p>
            <p>
              4.2.2. O Investidor deverá realizar atualização cadastral
              completa, obrigatoriamente:
            </p>
            <p>
              (i) a cada 12 (doze) meses, contados da data de seu cadastro
              inicial ou da última atualização cadastral realizada;
            </p>
            <p>(ii) sempre que solicitado pela Tutu Digital;</p>
            <p>
              (iii) quando ocorrer qualquer alteração nas informações cadastrais
              anteriormente fornecidas; ou
            </p>
            <p>
              (iv) quando exigido por mudanças na legislação ou regulamentação
              aplicável.
            </p>
            <p>4.2.3. A Tutu Digital poderá, a seu exclusivo critério:</p>
            <p>
              (i) solicitar a atualização cadastral em períodos menores que os
              mencionados na cláusula 4.2.2;
            </p>
            <p>
              (ii) solicitar documentos comprobatórios adicionais para validação
              das informações fornecidas; e
            </p>
            <p>
              (iii) suspender, limitar ou bloquear o acesso do Investidor à
              Plataforma e/ou às funcionalidades de investimento caso a
              atualização cadastral não seja realizada no prazo estabelecido ou
              caso sejam identificadas inconsistências nas informações
              fornecidas.
            </p>
            <p>
              4.2.4. O Investidor declara estar ciente que a atualização
              cadastral é requisito essencial para manutenção de sua relação com
              a Tutu Digital e para o cumprimento de obrigações regulatórias
              relacionadas à prevenção à lavagem de dinheiro e ao financiamento
              do terrorismo, sendo sua responsabilidade mantê-las atualizadas
              nos termos destes Termos e Condições.
            </p>
            <p class="title">5. NOME DE USUÁRIO E SENHA</p>
            <p>
              5.1. Em seu cadastro, você deverá, a fim de acessar áreas
              restritas da Plataforma Tutu, fornecer os seguintes dados:
              endereço completo, endereço de e-mail, nome de usuário, senha
              pessoal. Este cadastro será confirmado por e-mail. Cada vez que
              você acessar sua conta de Investidor ou Tomador na Plataforma
              Tutu, você precisará digitar seu nome de usuário e senha, que são
              intransferíveis (salvo consentimento prévio e por escrito da
              Tutu).
            </p>
            <p>
              5.2. O seu nome de usuário, senha e a confirmação por e-mail são
              os métodos que utilizamos para identificar você e por isso você
              deve mantê-los seguros. Você é responsável por todas as
              informações e atividades na Plataforma, independentemente da
              pessoa que estiver usando seu nome de usuário e senha. Qualquer
              violação de segurança, perda, roubo ou uso não autorizado de um
              nome de usuário, senha ou informações de segurança, devem ser
              notificados imediatamente através dos contatos indicados na
              Cláusula 21 abaixo.
            </p>
            <p>
              5.3. Você concorda em não adaptar ou contornar os sistemas
              existentes em conexão com a Plataforma.
            </p>
            <p>
              5.4. Reservamo-nos o direito de não atender suas instruções no
              caso de suspeitarmos que a pessoa logada em sua conta de
              Investidor ou Tomador Tutu não é você, bem como no caso de
              suspeitarmos de atividade ilegal ou fraudulenta ou de uso não
              autorizado.
            </p>
            <p class="title">
              6. REGRAS OPERACIONAIS, RISCO E RESPONSABILIDADES
            </p>
            <p>
              6.1. A Tutu poderá exigir do Tomador, de seus sócios e/ou
              administradores da empresa garantias pessoais ou reais (e.g.,
              aval, fiança, penhor ou alienação fiduciária) antes dos fundos
              serem liberados pela instituição financeira parceira para sua
              utilização. Nesse caso, a garantia será formalizada na própria CCB
              ou em instrumento separado.
            </p>
            <p>
              6.2. Após realização de procedimento de análise de crédito, de
              prevenção à lavagem de dinheiro e antifraude, será atribuído uma
              determinada avaliação ao crédito do Tomador (“Classificação”), por
              meio da qual será aferida a capacidade do Tomador de pagamento de
              eventual empréstimo a ser contraído, bem como os riscos oriundos
              da operação. A Classificação de risco atribuída pela Tutu a cada
              Tomador se baseia em (i) informações incluídas na própria
              requisição de Empréstimo; (ii) resultados obtidos a partir de
              verificação on-line feita com agências de referência de crédito,
              tais como Creditsafe, Equifax ou Experian; e (iii) algoritmos e
              outros mecanismos do modelo de crédito desenvolvido pela
              Plataforma Tutu. A partir de tais procedimentos, o Empréstimo
              poderá ou não ser aprovado, sendo que, no caso de aprovação, será
              atribuída determinada taxa de juros aplicável ao seu Empréstimo,
              conforme parâmetros estabelecidos pela Plataforma.
            </p>
            <p>
              6.3. Na sequência da avaliação acima, a requisição de Empréstimo
              do Tomador será disponibilizada na Plataforma Tutu, para os
              Investidores possam manifestar seu eventual interesse em investir
              recursos. Para tanto, determinados dados do Tomador e da empresa
              do Tomador serão disponibilizados na Plataforma no âmbito da
              requisição de Empréstimo.
            </p>
            <p>
              6.4. O Tomador concorda em permitir que o pedido de Empréstimo
              seja analisado, avaliado e disponibilizado na Plataforma para
              terceiros de boa fé, no âmbito da nossa relação com os
              Investidores na Plataforma.
            </p>
            <p>
              6.5. Uma vez que a requisição de Empréstimo pela Tomadora seja
              postada na Plataforma, o processo de formação de investimento irá
              começar e potenciais Investidores irão manifestar interesse em
              conferir parte ou a totalidade do valor que o Tomador solicitou
              para seu Empréstimo, o qual será lastreado em Cédula(s) de Crédito
              Bancário (“CCBs”) condicionada(s). Caso o valor mínimo informado
              na requisição de Empréstimo seja subscrito por Investidores na
              Plataforma, as CCBs terão atingido a condição para sua validade
              plena, sendo então ratificadas pela instituição financeira
              parceira e os recursos obtidos serão transferidos para a conta do
              Tomador.
            </p>
            <p>
              6.6. Os Empréstimos que não tiverem sido subscritos durante o
              processo de formação de investimento acima referido serão
              retirados da página de investimentos da Plataforma e a emissão das
              CCBs será cancelada pela instituição financeira parceira em 2
              (dois) dias úteis, a contar do término do prazo. Nesse caso, o
              Tomador não terá qualquer obrigação adicional advinda de sua
              requisição de Empréstimo. Os juros só serão acumulados a partir da
              data em que o processo de formação de investimento se efetivar e
              os valores refletidos nas CCBs forem transferidos pela instituição
              financeira parceira ao Tomador.
            </p>
            <p>
              6.7. O prazo para o processo de formação de investimento expirará
              no que ocorrer primeiro entre (i) a data de subscrição de um
              Empréstimo totalmente financiado e (ii) o prazo de 30 (trinta)
              dias corridos após a data de veiculação do investimento na
              Plataforma (salvo se acordado de outro modo pela Tutu, a seu
              exclusivo critério).
            </p>
            <p>
              6.8. As informações na página de requisição de Empréstimo poderão
              ser editadas a qualquer momento antes do início do processo de
              formação de investimento. Após o começo do processo de formação de
              investimento, o Tomador não poderá alterar a página de requisição
              de Empréstimo até o fim do processo de formação de investimento ou
              até o momento em que a totalidade do empréstimo seja quitada.
            </p>
            <p>
              6.9. A função principal da Tutu é intermediar a relação entre
              Tomadores e Investidores, a fim de reuni-los, fornecendo processo
              adequado para a celebração de empréstimos com a instituição
              financeira parceira (incluindo o desenvolvimento de acordos de
              forma de empréstimo padrão) em Plataforma Digital e para facilitar
              o pagamento e cobrança de valores devidos em relação a esses
              Empréstimos (incluindo certas ações limitadas em caso de
              descumprimento do Tomador, conforme estabelecido nestes Termos).
            </p>
            <p>
              6.9.1. Embora a Tutu agregue valor à análise de crédito como parte
              de sua atuação, a Classificação não pretende ser informativa ou
              vinculativa, de forma que a Tutu não assume qualquer
              responsabilidade por qualquer informação sobre um Tomador que seja
              disponibilizada aos potenciais Investidores por meio da Plataforma
              ou pela classificação de crédito dos Tomadores, sendo que o
              Investidor formará a sua própria opinião sobre a qualidade do
              crédito de um Tomador e realizará a sua própria análise e
              avaliação para cada Empréstimo. Ou seja, cabe ao Investidor a
              decisão e responsabilidade sobre o Investimento realizado para
              fins de empréstimo ao Tomador.
            </p>
            <p>
              6.10.1. A Classificação de Risco atribuída a cada Tomador é
              meramente informativa e reflete a análise da Tutu Digital no
              momento específico em que foi realizada, com base nas informações
              disponíveis à época. A Tutu Digital poderá, a qualquer tempo e a
              seu exclusivo critério, reclassificar o risco do Tomador em função
              de novas informações obtidas, alterações na situação financeira do
              Tomador ou mudanças no cenário macroeconômico, sem que isso
              constitua qualquer direito ao Tomador ou obrigação adicional aos
              Investidores.
            </p>
            <p>6.10.2. O Investidor declara e reconhece expressamente que:</p>
            <p>
              (i) a Classificação de Risco não constitui recomendação de
              investimento, garantia de retorno ou promessa de resultados;
            </p>
            <p>
              (ii) a decisão de investimento é tomada exclusivamente pelo
              Investidor, por sua conta e risco; e
            </p>
            <p>
              (iii) a inadimplência do Tomador não gera qualquer
              responsabilidade para a Tutu Digital, mesmo nos casos em que a
              Classificação de Risco original indicava baixa probabilidade de
              default.
            </p>
            <p>
              6.11. Para todos os Empréstimos, o processo de formação de
              investimento ficará aberto e disponível para manifestação de
              interesse dos Investidores até às 18 (dezoito) horas do 21º
              (vigésimo primeiro) dia corrido, contados do dia em que o referido
              processo. A Tutu poderá, a seu exclusivo critério, prorrogar este
              prazo, oportunidade em que o processo de formação de investimento
              permanecerá em aberto e disponível para manifestações de interesse
              por parte dos Investidores.
            </p>
            <p>
              6.12. Após ter sido atingido o valor mínimo de financiamento e o
              processo de formação do investimento ter sido bemsucedido, o
              Tomador desde já acorda em outorgar poderes à Tutu para agir por
              sua conta e ordem e celebrar Contrato de Empréstimo separado e
              juridicamente vinculativo perante a instituição financeira
              parceira, por meio da Plataforma, e com cada um dos Investidores.
              Da mesma forma, após a realização do Investimento, os Investidores
              outorgam poderes à Tutu para agir em juízo, ou fora dele, para a
              defesa de seus interesses em relação ao Investimento,
              especialmente nos casos em que os Tomadores restarem
              inadimplentes.
            </p>
            <p>
              6.13. Após o Contrato de Empréstimo ser gerado automaticamente
              pela Plataforma Tutu, os recursos relativos ao Empréstimo serão
              então transferidos para a conta bancária indicada pelo Tomador,
              sendo que tais valores poderão posteriormente ser sacados ou
              transferidos para outra conta bancária de sua escolha. Ressaltamos
              que, depois de transcorrido o processo de formação do
              investimento, o Empréstimo não poderá mais ser cancelado por
              qualquer motivo (embora, para que não restem dúvidas, este poderá
              ser repago em sua totalidade em qualquer momento).
            </p>
            <p>
              6.14. Cada Empréstimo terá o período de validade especificado no
              respectivo Contrato de Empréstimo gerado pela Plataforma Tutu, o
              qual será disponibilizado via plataforma após fechamento da
              operação.
            </p>
            <p>
              6.15. Não obstante qualquer outra cláusula destes Termos, em
              circunstâncias excepcionais e em sua absoluta discricionariedade,
              a Tutu (atuando como agente de garantia e procurador dos
              Investidores) pode concordar com o Tomador para reestruturar o
              Empréstimo e alterar o Contrato de Empréstimo para aumentar o
              prazo, com a possibilidade de alteração correspondente na taxa de
              juros. Para evitar dúvidas, o Tomador reconhece e concorda que a
              Tutu poderá exigir-lhe documentação complementar e/ou atualizada
              como condição para reestruturação do Empréstimo.
            </p>
            <p>
              6.15.1. O Investidor concorda, desde já, em outorgar poderes à
              Tutu para que esta atue como sua mandatária: (a) na reestruturação
              do Empréstimo e na alteração do Contrato de Empréstimo, desde que
              tal reestruturação e/ou alteração seja necessária e que a Tutu
              atue, de boa-fé, a fim de buscar eficiência e rentabilidade ao
              investimento realizado; e (b) na realização de novos investimentos
              a serem realizados por meio do saldo mantido na conta de pagamento
              do Investidor, gerida por instituição de pagamento parceira da
              Tutu, desde que o Investidor concorde expressamente. O Investidor
              concorda que poderá revogar os poderes outorgados nesta Cláusula a
              qualquer momento, mediante simples solicitação à Tutu.
            </p>
            <p>
              6.16. Se e na medida em que a Tutu se comprometer a reestruturar o
              Empréstimo de acordo com a cláusula 6.15, esta poderá cobrar uma
              taxa do Tomador, que será comunicada em cada operação.
            </p>
            <p>
              6.17. O Tomador concorda que os recursos advindos do Empréstimo
              serão utilizados exclusivamente para os fins declarados em sua
              requisição de Empréstimo.
            </p>
            <p>
              6.18 Nos casos em que os ativos estejam classificados em situação
              de inadimplência que implique provisionamento integral (100%),
              fica facultado exclusivamente à Tutu Digital realizar a venda ou
              cessão desses créditos para terceiros, objetivando mitigar
              eventuais perdas, sem que essa cessão ou venda gere qualquer
              responsabilidade adicional da Tutu Digital perante os
              Investidores.
            </p>
            <p>
              6.19. Após 900 (novecentos) dias de inadimplência, e tendo sido
              esgotadas todas as medidas de cobrança previstas na régua de
              cobrança da Tutu Digital – incluindo, mas não se limitando a
              notificações via SMS, WhatsApp, email, negativação, protesto,
              contato telefônico e análise da viabilidade econômica e jurídica
              de cobrança judicial –, a Tutu Digital poderá, a seu exclusivo
              critério, encerrar a gestão ativa desses créditos. A partir desse
              momento, os Investidores receberão apenas os valores efetivamente
              recuperados até a data do encerramento, sem qualquer correção,
              remuneração adicional ou compensação financeira. O direito de
              cobrança extrajudicial ou judicial será automaticamente
              transferido ao Investidor, que poderá adotar as providências
              cabíveis contra o Tomador, sem qualquer responsabilidade adicional
              da Tutu Digital sobre o crédito. Além disso, a Tutu Digital
              poderá, sem necessidade de aviso prévio, reportar os dados
              cadastrais, financeiros e de inadimplência do Tomador a bureaus de
              crédito, sistemas de proteção ao crédito, Banco Central do Brasil,
              instituições financeiras e demais órgãos reguladores. Caso a Tutu
              Digital identifique deterioração da capacidade financeira do
              Tomador, risco elevado de crédito, indícios de fraude ou outras
              circunstâncias relevantes, poderá tomar medidas preventivas, tais
              como: (i) vencimento antecipado da dívida; (ii) bloqueio
              preventivo de valores; (iii) exigência de garantias adicionais; e
              (iv) execução imediata das garantias existentes.
            </p>
            <p>
              Essas medidas poderão ser adotadas independentemente da
              configuração formal da inadimplência.
            </p>
            <p>
              6.19.1. A Tutu Digital fica expressamente autorizada a, sem prévio
              aviso e independentemente de qualquer formalidade adicional,
              reportar os dados cadastrais, financeiros e de inadimplência do
              Tomador a quaisquer bureaus de crédito, sistemas de proteção ao
              crédito, Banco Central do Brasil e demais órgãos reguladores, bem
              como compartilhar tais informações com instituições financeiras,
              potenciais cessionários de crédito e prestadores de serviço
              relacionados à cobrança.
            </p>
            <p>
              6.19.2. Caso a Tutu Digital identifique, a seu exclusivo critério,
              sinais de deterioração da capacidade financeira do Tomador,
              elevação do risco de crédito, indícios de fraude ou outras
              circunstâncias que possam comprometer o retorno do investimento,
              poderá adotar medidas preventivas, incluindo, mas não se limitando
              a: (i) vencimento antecipado da dívida; (ii) bloqueio preventivo
              de valores; (iii) exigência de garantias adicionais; e (iv)
              execução imediata das garantias existentes, independentemente da
              configuração formal de inadimplência.
            </p>
            <p>
              6.19.3. O Investidor declara estar ciente e concordar
              expressamente que a inadimplência do Tomador representa risco
              inerente à operação de investimento realizada por meio da
              Plataforma, não podendo, em hipótese alguma, ser atribuída à Tutu
              Digital. O Investidor reconhece que, ao investir na Plataforma,
              assume integral e exclusivamente os riscos de crédito dos
              Tomadores, conforme expressamente informado nas cláusulas 6.9.1,
              6.10, 6.10.1, 6.10.2 e 7.1.1 a 7.1.5 destes Termos.
            </p>
            <p>
              6.19.4. Na hipótese de o Investidor ajuizar medida judicial ou
              administrativa contra a Tutu Digital relacionada à inadimplência
              de Tomadores ou questões correlatas, e a Tutu Digital for
              considerada parte ilegítima ou a demanda for julgada improcedente,
              o Investidor, além das obrigações determinadas na sentença, deverá
              ressarcir a Tutu Digital pelos custos razoáveis incorridos com sua
              defesa. Tais custos incluem honorários advocatícios contratuais
              (limitados aos valores de referência da tabela da OAB), despesas
              com produção de provas essenciais e outras despesas diretamente
              relacionadas ao processo. O Investidor autoriza a Tutu Digital a,
              após o trânsito em julgado da decisão e mediante comunicação
              prévia com 5 (cinco) dias de antecedência, compensar tais valores
              com eventuais créditos do Investidor na Plataforma. Caso não haja
              créditos suficientes, o Investidor deverá efetuar o pagamento no
              prazo de 30 (trinta) dias após receber a comunicação detalhada dos
              valores.
            </p>
            <p>
              6.19.5. O Usuário reconhece que, embora a Tutu Digital possa
              divulgar procedimentos gerais de cobrança em seu site ou outros
              materiais informativos, tais informações têm caráter meramente
              orientativo e não constituem obrigação contratual específica. A
              Tutu Digital possui discricionariedade para definir, caso a caso,
              as medidas de cobrança mais adequadas, conforme sua avaliação da
              viabilidade econômica e jurídica, independente de eventuais prazos
              divulgados em materiais de marketing ou informações
              institucionais.
            </p>
            <p>
              6.20. O Investidor declara estar ciente de que a Classificação de
              Risco realizada pela Tutu tem caráter exclusivamente informativo e
              não constitui qualquer garantia de recebimento ou recomendação de
              investimento.
            </p>
            <p>
              6.20.1. O Investidor declara expressamente que a decisão de
              investir é de sua exclusiva responsabilidade, sendo ele o único
              responsável pelos riscos do crédito assumido. A Tutu Digital não
              assume qualquer responsabilidade por inadimplências, perdas
              financeiras ou oscilações do mercado.
            </p>
            <p>
              6.20.2. O Investidor reconhece que os retornos passados não
              garantem resultados futuros e que a realização de um investimento
              implica em riscos, podendo resultar na perda parcial ou total dos
              valores aportados.
            </p>
            <p>
              6.21.1. A Tutu Digital adota medidas estruturadas de cobrança,
              incluindo notificações extrajudiciais, escritórios de cobrança
              especialista em cobrança, protestos, execuções judiciais e outras
              estratégias conforme a viabilidade econômica e jurídica do caso.
            </p>
            <p>
              6.21.2. O Investidor declara estar ciente de que o tempo de
              recuperação dos créditos inadimplidos pode variar conforme as
              circunstâncias do Tomador e o andamento dos processos
              administrativos e judiciais. Dessa forma, não há garantias de
              prazos fixos para recuperação dos valores.
            </p>
            <p>
              6.21.3. A Tutu Digital poderá, a seu exclusivo critério,
              disponibilizar informações relevantes sobre processos de cobrança
              e recuperação de crédito por meio da Plataforma, sem que isso
              caracterize obrigação de atualização periódica ou individualizada.
              O Investidor reconhece que o andamento desses processos pode
              variar conforme fatores externos, como medidas judiciais,
              negociações extrajudiciais e condições do mercado, não cabendo à
              Tutu Digital a responsabilidade de prestar informações contínuas
              sobre cada caso específico.
            </p>
            <p>
              6.21.4. O Investidor reconhece que a Tutu Digital atua na defesa
              de seus interesses e busca maximizar as chances de recuperação do
              crédito, mas não pode ser responsabilizada por inadimplências ou
              demoras inerentes ao processo de cobrança.
            </p>
            <p class="title">7. INVESTIMENTOS E RENTABILIDADES</p>
            <p>
              7.1. Rentabilidade dos Investimentos. O Investidor compreende e
              aceita que:
            </p>
            <p>
              7.1.1. A rentabilidade dos investimentos realizados por meio da
              Plataforma Tutu depende exclusivamente do adimplemento dos
              Tomadores em relação às CCBs que lastreiam as operações, não
              havendo qualquer garantia de retorno por parte da Tutu Digital.
            </p>
            <p>
              7.1.2. As taxas de juros apresentadas na Plataforma representam a
              rentabilidade bruta potencial, antes da dedução de taxas, impostos
              e eventuais perdas decorrentes de inadimplência.
            </p>
            <p>
              7.1.3. A Tutu Digital não garante o recebimento de quaisquer
              valores pelo Investidor, uma vez que tais valores dependem
              exclusivamente do cumprimento das obrigações pelos Tomadores.
            </p>
            <p>
              7.1.4. Mesmo em caso de inadimplência total ou parcial do Tomador,
              a Tutu Digital terá direito a receber a taxa de assessoria
              contratada, sem que isso represente qualquer direito de regresso
              do Investidor contra a Tutu Digital.
            </p>
            <p>
              7.1.5. A Tutu Digital poderá, a seu exclusivo critério, realizar
              cessões de crédito, securitizações ou outras operações financeiras
              envolvendo os direitos creditórios dos Investidores, sempre
              visando obter a melhor liquidez e retorno possível, sem que isso
              implique em qualquer garantia de rentabilidade ou recuperação
              integral dos valores investidos.
            </p>
            <p class="title">8. TAXAS APLICÁVEIS</p>
            <p>8.1. TAXAS APLICÁVEIS AO TOMADOR</p>
            <p>
              8.1.1. Se o Tomador contratar um Empréstimo por meio da
              Plataforma, será cobrada:
            </p>
            <p>
              (a) uma taxa de assessoria devida à Tutu, sobre o valor
              emprestado, a qual será subtraída diretamente pela instituição
              financeira parceira do valor a ser repassado ao Tomador;
            </p>
            <p>
              (b) uma taxa de juros remuneratórios devida aos Investidores,
              pactuada no respectivo Empréstimo; e
            </p>
            <p>
              (c) eventuais outras taxas cobradas pela instituição financeira
              parceira da Tutu, a serem acordadas previamente com o Tomador.
            </p>
            <p>
              8.1.2. Assim, após as deduções das taxas acima, bem como dos
              impostos aplicáveis, o Tomador receberá o montante líquido do
              valor emprestado, conforme previamente informado na Plataforma.
            </p>
            <p>
              8.1.3. A Tutu poderá optar por dispensar ou reduzir as taxas
              indicadas acima ao longo do tempo.
            </p>
            <p>
              8.1.4. As taxas acima contemplam a remuneração de Tutu, dos
              Investidores e todos os demais agentes envolvidos.
            </p>
            <p>8.2. TAXAS APLICÁVEIS AO INVESTIDOR</p>
            <p>
              8.2.1 Ao subscrever parcial ou totalmente o valor requisitado para
              o Empréstimo por um Tomador por meio da Plataforma, será cobrada
              do Investidor uma taxa à alíquota de 4% (quatro por cento) sobre o
              valor do aporte, taxa essa que será deduzida, pela Plataforma
              Tutu, do montante da remuneração pagável ao Investidor em
              decorrência do aporte de recursos para o Empréstimo.
            </p>
            <p>
              8.2.2. A Tutu Digital poderá, a seu exclusivo critério, cobrar do
              Investidor taxas relacionadas a serviços operacionais, incluindo,
              mas não se limitando a:
            </p>
            <p>(i) Taxa de manutenção da conta de pagamento;</p>
            <p>(ii) Taxa para transferências via TED ou PIX;</p>
            <p>
              (iii) Taxa de inatividade, aplicável quando a conta permanecer sem
              movimentação por período superior a 6 (seis) meses;
            </p>
            <p>
              (iv) Taxa de processamento para aporte de recursos na Plataforma;
            </p>
            <p>
              (v) Taxa de processamento para resgate de recursos da Plataforma;
            </p>
            <p>
              8.2.3. Os valores das taxas mencionadas na cláusula 8.2.2 serão
              informados na Plataforma Tutu, podendo ser alterados mediante
              comunicação prévia aos Investidores.
            </p>
            <p>
              8.2.4. As taxas poderão ser cobradas no momento da prestação do
              serviço ou debitadas diretamente da conta de pagamento do
              Investidor.
            </p>
            <p>
              8.2.5. O Investidor autoriza expressamente a Tutu Digital a
              debitar automaticamente de sua conta de pagamento quaisquer
              valores devidos a título de taxas, sem necessidade de notificação
              prévia específica para cada débito.
            </p>
            <p>
              8.2.6. A Tutu Digital poderá, a seu exclusivo critério, bloquear
              temporariamente o saldo disponível na conta do Investidor nas
              seguintes situações: (i) suspeita de fraude; (ii) verificação de
              conformidade; (iii) ordem judicial; (iv) indícios de movimentação
              atípica; (v) necessidade de compensação de valores; ou (vi) em
              quaisquer outras situações que possam comprometer a segurança das
              operações na Plataforma. O desbloqueio ocorrerá após a resolução
              da situação que motivou o bloqueio.
            </p>
            <p class="title">9. PAGAMENTO DO EMPRÉSTIMO</p>
            <p>
              9.1. Os pagamentos serão estabelecidos no Contrato de Empréstimo e
              serão efetuados na conta de pagamento do Investidor, gerida por
              instituição de pagamento parceira da Tutu, aberta quando do
              cadastro do Investidor na Plataforma Tutu.
            </p>
            <p>
              9.2. Os pagamentos relativos às parcelas devidas do Empréstimo,
              bem como respectivas especificações, serão enviados mensalmente
              aos Tomadores por e-mail e podem ser requisitados, a qualquer
              momento, pelo e-mail
              <a
                href="&#x6d;&#97;&#x69;&#x6c;&#x74;&#111;&#x3a;&#113;&#x75;&#x65;&#x72;&#111;&#x40;&#x74;&#x75;&#x74;&#x75;&#100;&#x69;&#103;&#105;&#x74;&#x61;&#x6c;&#x2e;&#99;&#111;&#109;&#46;&#x62;&#114;"
                >&#113;&#x75;&#x65;&#x72;&#111;&#x40;&#x74;&#x75;&#x74;&#x75;&#100;&#x69;&#103;&#105;&#x74;&#x61;&#x6c;&#x2e;&#99;&#111;&#109;&#46;&#x62;&#114;</a
              >. O Tomador poderá efetuar o pagamento do Empréstimo inteiro, em
              qualquer momento, sem custo adicional, desde que pague o valor
              principal em aberto, juntamente com os juros devidos, até a data
              em que o Empréstimo for repago.
            </p>
            <p>
              9.3. A conta de pagamento do Investidor poderá realizar e receber
              transferências de recursos de forma instantânea por meio do PIX, o
              qual será operacionalizado por meio da instituição de pagamento
              parceira da Tutu.
            </p>
            <p class="title">10. GARANTIAS</p>
            <p>
              10.1. A Tutu poderá lhe solicitar a outorga de garantias a
              depender de sua classificação de crédito. Eventuais garantias
              serão previamente acordadas com base em parâmetros condizentes ao
              empréstimo contratado e poderão ser previstas na própria CCB ou em
              instrumento de garantia apartado.
            </p>
            <p>
              10.2. Em caso de serem indicados avalistas nos Contratos de
              Empréstimos, todos estes são obrigados a assinar o contrato,
              ficando ciente que poderão responder pelas dívidas dos Tomadores.
            </p>
            <p class="title">11. OUTORGA DE PODERES</p>
            <p>
              11.1. Você, desde já, nomeia a Tutu como sua procuradora com
              poderes especiais para, em seu nome e por sua conta, negociar e
              obter crédito perante instituições financeiras, assinar contratos
              de empréstimos, abrir conta (corrente ou de pagamento) para
              movimentar os valores financiados, movimentar a conta aberta para
              tal finalidade, acertar prazos, juros e ônus da dívida, repactuar
              taxas de juros, emitir títulos representativos do débito perante
              as instituições financeiras, ou ainda, substabelecer em todo ou em
              parte o mandato outorgado, conforme sua condição de Investidor ou
              Tomador.
            </p>
            <p>
              11.1.1. O mandato outorgado à Tutu Digital nos termos da cláusula
              11.1 é concedido em caráter irrevogável e irretratável, como
              condição essencial do negócio jurídico, na forma do artigo 684 do
              Código Civil Brasileiro, e permanecerá válido mesmo em caso de
              morte, incapacidade civil, falência, recuperação judicial ou
              extrajudicial do Usuário outorgante, enquanto existirem operações
              em aberto ou obrigações pendentes do Usuário na Plataforma.
            </p>
            <p>
              11.1.2. Os poderes outorgados à Tutu Digital contemplam, além
              daqueles expressamente mencionados nestes Termos, todos os poderes
              inerentes e necessários para o cumprimento das finalidades do
              mandato, incluindo poderes para transigir, firmar compromissos,
              renunciar a direitos, receber e dar quitação, sempre visando a
              proteção dos interesses dos Investidores e a eficiência das
              operações na Plataforma.
            </p>
            <p>
              11.2. Tendo em vista o papel da Tutu de intermediadora, conforme
              elucidado no item 6.9, ela terá legitimidade ativa para propor
              eventuais ações de execução de título extrajudicial em face dos
              Tomadores. Em outras palavras, atuando a Tutu em nome das partes
              interessadas, fica-lhe outorgado mandato com poderes específicos
              para protestar e executar eventuais CCBs emitidas.
            </p>
            <p>
              11.3. O Tomador desde já autoriza expressamente a Tutu a
              compartilhar seus dados cadastrais e do empréstimo pretendido com
              as instituições financeiras e seus Investidores a fim de permitir
              a obtenção dos fundos para viabilização de seu empréstimo.
            </p>
            <p class="title">12. INADIMPLEMENTO DO TOMADOR</p>
            <p>
              12.1. Se, em algum momento, você acreditar que poderá não ser
              capaz de fazer um ou mais pagamentos devidos nos termos de um
              Contrato de Empréstimo, por favor contate-nos imediatamente. Se
              você perder um pagamento ou pagar apenas parcialmente o montante
              devido, nós entraremos em contato com você e lhe pediremos para
              explicar os motivos que levaram ao inadimplemento. Se nossa
              tentativa de cobrança falhar, dois dias após a data em que o
              pagamento era devido a sua conta será entendida como conta em
              atraso, ao passo que vamos continuar a tentar receber os valores
              devidos. Caso a situação de inadimplência persista por cinco dias
              ou mais, a Tutu poderá protestar e executar judicialmente as CCBs
              que lastrearam o empréstimo, além de quaisquer outras medidas
              extrajudiciais que julgar necessárias, incluindo a solicitação de
              inclusão do nome do Tomador e seus sócios/administradores no
              cadastro de maus pagadores.
            </p>
            <p>
              12.2. Caso o pagamento ainda não tenha sido feito no prazo
              estipulado em contrato, poderá ser cobrado do Tomador: (i) multa
              de 2% sobre o valor total emprestado e (ii) juros moratórios de 1%
              ao mês, além da correção do valor devido, mais despesas e
              eventuais honorários que tenha incorrido para fins de recuperação
              do valor devido e proteção dos investidores, ao passo que
              referidos valores deverão ser pagos em 2 (dois) dias úteis a
              contar do recebimento da respectiva cobrança.
            </p>
            <p>
              12.3. Eventuais atrasos ou descumprimentos por parte do Tomador
              poderão impactar negativamente em sua classificação de crédito
              para futuros empréstimos. Por favor, leia nossa política de
              privacidade para obter mais detalhes sobre como podemos divulgar
              informações sobre você.
            </p>
            <p>
              12.4. Em caso de inadimplemento, a Tutu poderá tomar as medidas
              judiciais e extrajudiciais para satisfação do débito dos Tomadores
              junto à Tutu e/ou aos Investidores, podendo, ainda, suspender ou
              bloquear o acesso do Tomador na Plataforma Tutu.
            </p>
            <p class="title">13. VENCIMENTO ANTECIPADO</p>
            <p>
              13.1. Além dos casos previstos em lei, o presente Contrato estará
              automática e antecipadamente vencido, com a imediata exigibilidade
              de todas as obrigações contraídas pelo Tomador no presente
              instrumento, independentemente de qualquer notificação,
              interpelação ou comunicação, judicial ou extrajudicial, nas
              seguintes hipóteses:
            </p>
            <p>
              (a) se o Tomador deixar de observar qualquer das suas obrigações
              previstas neste Contrato;
            </p>
            <p>
              (b) aplicação do valor do Empréstimo em finalidade diversa da
              informada na Plataforma;
            </p>
            <p>
              (c) alteração do objeto social do Tomador ou da natureza de seus
              negócios conforme conduzidos na data da submissão do pedido de
              Empréstimo na Plataforma;
            </p>
            <p>
              (d) alteração de dados, endereço ou quadro societário, sem a
              devida comunicação à Tutu;
            </p>
            <p>
              (e) alteração, extinção, liquidação ou dissolução do Tomador,
              requerimento de autofalência, pedido de recuperação judicial ou
              extrajudicial formulado pelo Tomador ou pedido de falência do
              Tomador ou eventos análogos, independentemente do deferimento do
              respectivo pedido, bem como estar tomador sujeito a qualquer forma
              de concurso de credores;
            </p>
            <p>
              (f) não obtenção, cancelamento, revogação, intervenção, extinção
              ou suspensão da concessão, autorizações, aprovações, registros e
              licenças, inclusive, as ambientais exigidas para a operação do
              Tomador ou para o desenvolvimento de seus projetos;
            </p>
            <p>
              (g) se houver fusão, cisão, incorporação, reorganização
              societária, transferência direta ou indireta do controle acionário
              ou qualquer forma de reorganização societária do Tomador, que não
              tenha sido prévia e expressamente aprovada pela Tutu;
            </p>
            <p>
              (h) não pagamento das parcelas do Empréstimo na respectiva data de
              vencimento ou vencimento antecipado de qualquer dívida e/ou
              obrigação financeira do Tomador; e
            </p>
            <p>
              (i) o protesto legítimo de títulos contra o Tomador, salvo se o
              protesto tiver sido efetuado por erro ou má fé de terceiros, desde
              que validamente comprovados pelo Tomador, ou, se for cancelado em
              qualquer hipótese, no prazo máximo de 72 (setenta e duas) horas
              contadas a partir da data da comunicação feita ao Tomador nesse
              sentido.
            </p>
            <p class="title">14. EXTINÇÃO DE CADASTRO TUTU</p>
            <p>
              14.1. Se você não quiser mais ser um Usuário da Plataforma, poderá
              solicitar o cancelamento do seu cadastro diretamente na
              Plataforma. A Tutu Digital analisará o pedido e procederá ao
              cancelamento no prazo de até 15 (quinze) dias úteis, desde que não
              haja pendências financeiras, contratuais ou regulatórias em seu
              cadastro.
            </p>
            <p>
              14.2. A Tutu Digital poderá, ainda, efetuar o cancelamento de seu
              cadastro e sua exclusão da Plataforma nas seguintes hipóteses:
            </p>
            <p>
              a) Se você violar estes Termos ou os demais Termos e Condições de
              Uso e Política de Privacidade;
            </p>
            <p>
              b) Se você violar qualquer termo ou condição do Contrato de
              Empréstimo ou qualquer documento relacionado a este;
            </p>
            <p>
              c) Se o Tomador celebrar novo Contrato de Empréstimo sem garantia
              (ou qualquer acordo que vise à obtenção de financiamento) com
              terceiros, sempre que o montante total de financiamento com
              terceiros seja superior a 30% (trinta por cento) do montante total
              emprestado para o Tomador através da Plataforma, sem o prévio
              consentimento por escritoda Tutu;
            </p>
            <p>
              d) Se o Tomador outorgar quaisquer ativos ou garantias para
              terceiros após a data de celebração do Contrato de Empréstimo, sem
              o consentimento prévio e por escrito da Tutu;
            </p>
            <p>
              e) Se houver fundada suspeita de que você cometeu fraude, foi
              envolvido em lavagem de dinheiro ou quaisquer outras atividades
              criminosas;
            </p>
            <p>
              f) Se você utilizar a Plataforma ou informações disponíveis nela
              em benefício de terceiros sem o consentimento prévio e por escrito
              da Tutu;
            </p>
            <p>
              g) Se você utilizar a Plataforma de qualquer uma das seguintes
              formas: i. De modo que cause ou possa causar interrupção,
              danificação ou qualquer outro efeito negativo à Plataforma ou ao
              seu acesso; ii. Para fins fraudulentos ou em conexão com uma
              atividade criminosa; iii. Para enviar, usar ou reutilizar qualquer
              material que seja ilegal, ofensivo, abusivo, indecente,
              difamatório, obsceno ou ameaçador; ou que viole direitos autorais,
              marcas, privacidade ou qualquer outro direito; iv. Para causar
              aborrecimento, inconveniência ou ansiedade desnecessária à Tutu
              Digital e/ou seus usuários.
            </p>
            <p>
              14.3. O cancelamento de seu cadastro na Tutu Digital não resultará
              na rescisão de qualquer Contrato de Empréstimodo qual você seja
              parte nesse momento. Ou seja, você permanecerá obrigado a cumprir
              com o Contrato de Empréstimo até sua quitação integral.
            </p>
            <p>
              14.4. A Tutu Digital reserva-se o direito de cancelar
              unilateralmente a prestação dos serviços e encerrar o acesso do
              Investidor à Plataforma nas seguintes hipóteses:
            </p>
            <p>
              a) Conta Digital Tutu permanecer inativa e/ou com saldo zerado por
              mais de 6 (seis) meses consecutivos;
            </p>
            <p>
              b) Violação pelo Investidor das disposições previstas nestes
              Termos;
            </p>
            <p>
              c) Operações identificadas como incompatíveis com os padrões de
              uso definidos pela Tutu Digital;
            </p>
            <p>
              d) Ausência reiterada no envio de documentação ou esclarecimentos
              solicitados pela Tutu Digital;
            </p>
            <p>e) Falecimento do Investidor;</p>
            <p>
              f) Contas com saldo residual inferior a R$ 50,00 (cinquenta reais)
              sem movimentação por período superior a 9 (nove) meses;
            </p>
            <p>
              g) Contas sem qualquer movimentação por período superior a 12
              (doze) meses, independentemente do saldo;
            </p>
            <p>
              h) Por qualquer outro motivo, desde que mediante comunicação
              prévia ao Investidor, a exclusivo critério da Tutu Digital. A Tutu
              Digital poderá encerrar contas inativas por mais de 12 meses
              consecutivos e/ou que não possuam saldo remanescente.
            </p>
            <p>
              14.4.1. Nos casos previstos nas alíneas (a), (f) e (g) do item
              14.4, a Tutu Digital notificará o Investidor com pelo menos 15
              (quinze) dias de antecedência, informando sobre o iminente
              encerramento da conta.
            </p>
            <p>
              14.4.2. No caso previsto na alínea (f) do item 14.4, caso a conta
              permaneça inativa e com saldo residual inferior a R$ 50,00
              (cinquenta reais) por período superior a 9 (nove) meses, a Tutu
              Digital notificará o usuário sobre o encerramento da conta.
            </p>
            <p>
              14.4.3. As taxas de manutenção e inatividade mencionadas na
              cláusula 8.2.2 serão debitadas diretamente do saldo disponível na
              conta do Investidor até seu esgotamento completo, momento em que a
              Tutu Digital poderá proceder ao encerramento da conta,
              independentemente de notificação adicional.
            </p>
            <p>
              14.4.4. O Investidor reconhece e concorda que a Tutu Digital
              poderá encerrar contas com saldo zerado ou valores residuais após
              o período de inatividade indicado, sem que isso caracterize
              inadimplemento contratual ou gere qualquer tipo de indenização.
            </p>
            <p class="title">15. CONDIÇÕES GERAIS</p>
            <p>
              15.1. As informações fornecidas na Plataforma são direcionadas
              exclusivamente ao uso por pessoas e entidades que atendam aos
              critérios estabelecidos nas cláusulas acima e não se destinam à
              distribuição ou uso por qualquer pessoa ou entidade que não para
              os fins estipulados na Plataforma.
            </p>
            <p>
              15.2. É permitido baixar e imprimir conteúdo a partir da
              Plataforma exclusivamente para seu uso pessoal ou no curso de seu
              negócio, na medida necessária para utilizar os serviços prestados
              nesta Plataforma. O conteúdo disponibilizado na Plataforma não
              pode ser copiado ou reproduzido, modificado, redistribuído ou
              utilizado de qualquer maneira ou para qualquer outro fim sem o
              nosso consentimento prévio e expresso por escrito.
            </p>
            <p>
              15.3. Nós não somos responsáveis pelo conteúdo baixado ou postado
              por investidores ou Tomadores na Plataforma. A Tutu não irá editar
              o conteúdo baixado ou postado na Plataforma.
            </p>
            <p>
              15.4. Faremos todo o possível para permitir o acesso ininterrupto
              à Plataforma. No entanto, o acesso à Plataforma poderá,
              eventualmente, ser suspenso ou restringido, a qualquer momento.
            </p>
            <p>
              15.5. Você, desde já, concorda em usar a Plataforma apenas para
              fins legais e de forma a não infringir direitos de terceiros ou
              restringir ou inibir o uso por parte de qualquer outro usuário da
              Plataforma.
            </p>
            <p>
              15.6. Você declara que tomou todas as precauções razoáveis para
              garantir que todos os dados enviados ou submetidos à Plataforma
              estão livres de vírus ou qualquer outro software malicioso que
              possa causar efeitos danosos à Plataforma ou seus usuários.
            </p>
            <p>
              15.7. O conteúdo e o material disponíveis na Plataforma são apenas
              para fins informativos e não devem ser considerados como uma
              oferta, solicitação, convite, aconselhamento ou recomendação de
              compra ou venda de investimentos, títulos ou quaisquer outros
              serviços financeiros ou produto bancário. Se você não tiver
              certeza se um produto é adequado ao seu perfil, você deve entrar
              em contato com um consultor financeiro independente.
            </p>
            <p>
              15.8. Você é responsável por todos os custos eventualmente
              incorridos por você em razão do acesso à Plataforma.
            </p>
            <p>
              15.9. Nós não assumimos qualquer responsabilidade por seu uso da
              Plataforma, sendo que tal uso é inteiramente por sua conta e
              risco. Enquanto tomamos precauções razoáveis para evitar a
              existência de vírus ou outros programas maliciosos na Plataforma,
              não assumimos qualquer responsabilidade caso estes venham a
              existir na Plataforma. É de sua responsabilidade usar, atualizar e
              manter o software antivírus apropriado para o seu computador.
            </p>
            <p>
              15.10. A informação transmitida através da Plataforma passa por
              redes públicas de telecomunicações. Nós não temos qualquer
              responsabilidade se as comunicações enviadas por meio da
              Plataforma forem interceptadas por terceiros ou incorretamente
              entregues ou não entregues.
            </p>
            <p>
              15.11. A Plataforma pode conter links para sites de terceiros. Nós
              não aceitamos nenhuma responsabilidade ou obrigação por qualquer
              material fornecido por ou contido em qualquer site de terceiros,
              cujo link seja disponibilizado na Plataforma ou qualquer uso de
              dados pessoais por terceiros a partir de tais links.
            </p>
            <p>
              15.12 A Tutu Digital não será responsável por eventuais
              interrupções ou falhas técnicas que possam ocorrer na Plataforma,
              especialmente quando decorrentes de ações de terceiros ou
              manutenções programadas ou emergenciais. O Usuário declara estar
              ciente de que interrupções temporárias podem ocorrer sem aviso
              prévio, não configurando qualquer direito a indenização.
            </p>
            <p>
              15.13. A Tutu Digital não é parte contratual direta nas operações
              financeiras realizadas na Plataforma entre Tomadores, Investidores
              e a instituição financeira parceira, atuando apenas como
              intermediadora e mandatária dos Investidores para formalização dos
              contratos.
            </p>
            <p>
              15.13.1. A assinatura da CCB pela Tutu Digital não implica em
              assunção de riscos financeiros ou responsabilidade solidária,
              sendo os Tomadores e Investidores os únicos responsáveis pelas
              obrigações decorrentes das operações.
            </p>
            <p class="title">16. PRIVACIDADE</p>
            <p>
              16.1. Você concorda que toda e qualquer informação pessoal ou da
              empresa que você venha a fornecer para nós através desta
              plataforma pode ser tratada, recolhida, armazenada, processada e
              utilizada de acordo com a nossa política de privacidade atual, a
              qual atende ao disposto na Lei nº 13.709, de 14 de agosto de 2018.
            </p>
            <p class="title">17. DIREITOS DE PROPRIEDADE INTELECTUAL</p>
            <p>
              17.1. Nós possuímos todos os direitos autorais e de propriedade
              intelectual, presentes e futuros, da Plataforma Tutu, das marcas
              registradas e não registradas, direitos de design registrados ou
              não registrados, direitos de banco de dados e todos os outros
              direitos de propriedade intelectual em relação à Plataforma Tutu.
            </p>
            <p>
              17.2. Se na medida em que eventuais direitos de propriedade
              intelectual da sua titularidade, por força de lei ou de qualquer
              outra forma, venham a ser veiculados em nossa Plataforma, você
              concorda em nos autorizar, bem como a terceiros por nós
              autorizados, a utilizar e veicular essa propriedade intelectual em
              nossa Plataforma.
            </p>
            <p>
              17.3. Você irá manter a sua propriedade sobre todos os direitos de
              propriedade intelectual sobre os dados que você submeter à
              Plataforma Tutu. Você concede-nos o direito exclusivo, livre de
              royalties, licença por prazo indeterminado, em todo o mundo, para
              usar, copiar, distribuir, publicar e transmitir esses dados de
              qualquer maneira relacionada à nossa Plataforma.
            </p>
            <p>
              17.4. A Tutu vai envidar seus melhores esforços para garantir a
              segurança dos dados disponibilizados, todavia a Tutu não se
              responsabiliza pela veracidade destes ou por sua guarda e
              manutenção.
            </p>
            <p class="title">18. DO USO DA IMAGEM DO TOMADOR</p>
            <p>
              18.1. O Tomador autoriza a Tutu a utilizar seu nome completo e
              fotografia de perfil de redes sociais (nome e fotografia,
              conjuntamente “Perfil”) para divulgar a demanda de crédito da
              empresa aos Investidores, no âmbito da Plataforma Tutu.
            </p>
            <p>
              18.1.1. O Usuário concede à Tutu Digital licença ampla,
              irrevogável, perpétua, irretratável, mundial, gratuita e
              transferível para utilizar, reproduzir, modificar, adaptar,
              publicar, traduzir, distribuir, sublicenciar e exibir publicamente
              seu nome, logotipo, marcas, imagem, depoimentos e casos de sucesso
              para fins comerciais, promocionais, educacionais e informativos,
              em qualquer mídia ou formato, conhecido ou que venha a ser
              desenvolvido no futuro.
            </p>
            <p>
              18.1.2. O Usuário concorda em não contestar, direta ou
              indiretamente, a validade ou titularidade de quaisquer direitos de
              propriedade intelectual da Tutu Digital, e reconhece que não
              adquire quaisquer direitos sobre a marca, nome empresarial,
              logotipos, domínios, software, conteúdo, metodologias, processos
              ou qualquer outro elemento de propriedade intelectual da Tutu
              Digital em decorrência destes Termos ou do uso da Plataforma.
            </p>
            <p class="title">19. DA RESPONSABILIDADE DOS USUÁRIOS</p>
            <p>
              19.1. O Usuário será integralmente responsável por quaisquer
              prejuízos, diretos ou indiretos, causados à Tutu Digital em razão
              de ações ou omissões praticadas em violação destes Termos,
              incluindo, mas não se limitando a atos ilícitos, fraudulentos,
              negligentes ou decorrentes de violação de obrigações contratuais.
              O Usuário se compromete, desde já, a indenizar integralmente a
              Tutu Digital por todos os danos que esta venha a sofrer em razão
              dessas ações ou omissões.
            </p>
            <p>
              19.2. A responsabilidade da Tutu Digital perante os Usuários
              limita-se exclusivamente aos danos diretos, comprovadamente
              decorrentes da violação culposa ou dolosa das obrigações
              expressamente assumidas nestes Termos. Em nenhuma hipótese será a
              Tutu Digital responsável por danos indiretos, incidentais,
              consequenciais ou especiais, incluindo lucros cessantes ou
              prejuízos decorrentes das decisões de investimento ou empréstimo
              tomadas pelos Usuários. O Usuário reconhece e aceita que decisões
              de investimento envolvem riscos e são tomadas exclusivamente sob
              sua responsabilidade.
            </p>
            <p>
              19.3 A Tutu Digital limita expressamente sua responsabilidade aos
              danos diretos comprovadamente causados por ação ou omissão culposa
              ou dolosa diretamente relacionada às obrigações previstas nestes
              Termos. Sob nenhuma circunstância será responsável por danos
              indiretos, incidentais, consequenciais ou especiais, incluindo,
              sem limitação, lucros cessantes, perdas financeiras decorrentes de
              decisões de investimento ou empréstimo tomadas pelos Usuários,
              expectativas frustradas de retorno financeiro, prejuízos derivados
              de oscilações de mercado ou falhas na análise ou compreensão dos
              riscos por parte dos Usuários. O Usuário declara estar plenamente
              ciente de que as decisões tomadas com base nas informações da
              Plataforma Tutu são exclusivamente suas, assumindo integralmente
              os riscos e eventuais prejuízos delas decorrentes, não cabendo,
              portanto, qualquer ação indenizatória contra a Tutu Digital por
              esses motivos.
            </p>
            <p class="title">20. DA RESPONSABILIDADE DA TUTU</p>
            <p>
              20.1. A Tutu não assume qualquer responsabilidade por eventuais
              perdas ou danos que possam vir a ser sofridos a partir da
              participação do Investidor ou Tomador da Plataforma ou da
              utilização dos serviços fornecidos através da Plataforma, exceto
              quando tal perda ou dano decorra da nossa violação destes Termos e
              Condições do Investidor e Tomador ou seja causado por negligência,
              dolo ou fraude por parte da Tutu ou nossos funcionários. Nós não
              somos responsáveis por qualquer violação destes Termos e Condições
              do Investidor e Tomador decorrentes de circunstâncias fora de
              nosso controle.
            </p>
            <p class="title">21. CONTATO TUTU</p>
            <p>
              21.1. Se você tiver quaisquer dúvidas sobre estes Termos e
              Condições do Investidor e Tomador, por favor, entre em contato
              através do e-mail
              <a
                href="&#109;&#x61;&#x69;&#108;&#x74;&#x6f;&#58;&#x71;&#117;&#x65;&#114;&#x6f;&#64;&#116;&#117;&#x74;&#117;&#100;&#105;&#103;&#105;&#x74;&#97;&#x6c;&#46;&#99;&#x6f;&#109;&#46;&#x62;&#114;"
                >&#x71;&#117;&#x65;&#114;&#x6f;&#64;&#116;&#117;&#x74;&#117;&#100;&#105;&#103;&#105;&#x74;&#97;&#x6c;&#46;&#99;&#x6f;&#109;&#46;&#x62;&#114;</a
              >
              ou por meio do site da Tutu:
              <a href="http://www.tutudigital.com.br/">www.tutudigital.com.br</a
              >.
            </p>
            <p>
              21.2. Se você quiser fazer uma reclamação formal, poderá fazê-lo
              por escrito, por correio (Avenida Paulista, nº 1.374, 11º andar)
              ou por e-mail (<a
                href="&#x6d;&#97;&#x69;&#x6c;&#x74;&#x6f;&#x3a;&#113;&#117;&#x65;&#114;&#111;&#64;&#x74;&#x75;&#116;&#117;&#100;&#x69;&#103;&#x69;&#x74;&#x61;&#x6c;&#x2e;&#x63;&#111;&#109;&#x2e;&#98;&#114;"
                >&#113;&#117;&#x65;&#114;&#111;&#64;&#x74;&#x75;&#116;&#117;&#100;&#x69;&#103;&#x69;&#x74;&#x61;&#x6c;&#x2e;&#x63;&#111;&#109;&#x2e;&#98;&#114;</a
              >
              ou
              <a
                href="&#x6d;&#97;&#x69;&#108;&#116;&#x6f;&#x3a;&#x61;&#100;&#109;&#105;&#x6e;&#x40;&#116;&#117;&#116;&#x75;&#100;&#x69;&#x67;&#105;&#116;&#97;&#x6c;&#46;&#99;&#111;&#x6d;&#46;&#98;&#x72;"
                >&#x61;&#100;&#109;&#105;&#x6e;&#x40;&#116;&#117;&#116;&#x75;&#100;&#x69;&#x67;&#105;&#116;&#97;&#x6c;&#46;&#99;&#111;&#x6d;&#46;&#98;&#x72;</a
              >).
            </p>
            <p class="title">22. AS ALTERAÇÕES DESTES TERMOS E CONDIÇÕES</p>
            <p>
              22.1. Poderemos atualizar ou alterar unilateralmente estes Termos
              e Condições do Investidor e Tomador de tempos em tempos, a fim de
              cumprir a legislação aplicável ou de satisfazer as nossas mudanças
              de negócios. Eventuais alterações serão previamente informadas por
              e-mail e publicadas na Plataforma. Ao continuar a utilizar a
              Plataforma, você concorda em permanecer vinculado aos Termos
              atualizados e/ou alterados.
            </p>
            <p>
              22.2. Caso o Usuário não concorde com as atualizações destes
              Termos e Condições, ele poderá solicitar o encerramento de sua
              conta dentro de 15 dias após a notificação. Se não houver
              manifestação dentro deste prazo, a conta poderá ser suspensa ou
              encerrada, a critério da Tutu Digital.
            </p>
            <p>
              22.3. O Usuário reconhece que quaisquer informações, dados
              estatísticos, casos de sucesso ou outros conteúdos de natureza
              promocional apresentados no site da Tutu Digital, em suas redes
              sociais ou em quaisquer outros materiais de marketing têm caráter
              meramente ilustrativo e informativo, não constituindo garantias
              contratuais ou promessas de resultados. Tais conteúdos representam
              situações históricas ou potenciais que podem não se repetir no
              futuro, não gerando qualquer direito ou expectativa legítima ao
              Usuário.
            </p>
            <p class="title">23. OUTROS TERMOS IMPORTANTES</p>
            <p>
              23.1. A nulidade ou invalidade de qualquer das disposições destes
              Termos e Condições do Investidor e Tomador não prejudicará a
              validade e eficácia das demais cláusulas dos Termos e Condições de
              Uso, Política de Privacidade ou do Contrato de Empréstimo. Caso
              alguma decisão judicial pronuncie-se sobre a invalidade ou
              ineficácia de qualquer das disposições destes Termos e Condições
              do Investidor e Tomador, as Partes deverão substituir a regra
              inquinada por outra que, sendo lícita, permita sejam alcançados,
              na maior extensão possível, os resultados práticos inicialmente
              visados.
            </p>
            <p>
              23.2. Todas as renúncias, indenizações e exclusões nestes Termos e
              Condições do Investidor e Tomador sobreviverão à rescisão do
              acordo entre nós, por qualquer razão.
            </p>
            <p>
              23.3. Podemos, no todo ou em parte, transigir, renunciar ou adiar,
              na nossa absoluta discrição, qualquer responsabilidade devida a
              nós ou direito concedido a nós nestes Termos e Condições, sem de
              modo algum prejudicá-los ou afetá-los.
            </p>
            <p>
              23.4. As Partes reconhecem que o não exercício, por qualquer
              delas, ou o atraso no exercício de qualquer direito que lhes seja
              assegurado por este instrumento ou por lei, não constituirá
              novação ou renúncia de tal direito, nem prejudicará o seu eventual
              exercício, a qualquer tempo. A renúncia, por qualquer das Partes,
              de algum dos direitos ou poderes previstos neste instrumento
              somente será válida se formalizada por escrito.
            </p>
            <p>
              23.5. Estes Termos, os Termos e Condições de Uso, a Política de
              Privacidade e os Contratos de Empréstimo estabelecem a totalidade
              do acordo entre você e nós com relação ao seu uso da Plataforma,
              sendo que estes documentos substituem todas e quaisquer
              representações, comunicações e acordos anteriores (escrito ou
              oral) feito por você ou por nós.
            </p>
            <p>
              23.6. A Tutu poderá ceder, transferir, novar ou não exercer
              qualquer dos seus direitos ao abrigo destes, por si só ou através
              de qualquer empresa ou outra entidade legal que esteja sob o
              controle ou participação acionária da Tutu.
            </p>
            <p>
              23.7. A relação entre a Tutu Digital e seus Usuários não se
              enquadra na definição de relação de consumo, pois a Tutu Digital
              atua exclusivamente como intermediadora de empréstimos e
              investimentos entre Tomadores e Investidores. Dessa forma, os
              serviços prestados pela Plataforma não estão sujeitos às
              disposições do Código de Defesa do Consumidor (Lei nº 8.078/1990),
              sendo regidos pela legislação civil e comercial aplicável ao
              mercado financeiro.
            </p>
            <p>O Usuário expressamente reconhece que:</p>
            <p>
              (i) A Plataforma Tutu não fornece produtos ou serviços de consumo,
              mas um ambiente de intermediação de crédito e investimento;
            </p>
            <p>
              (ii) A adesão à Plataforma não implica qualquer garantia de
              retorno financeiro ou proteção contra riscos de mercado;
            </p>
            <p>
              (iii) Todas as decisões tomadas pelo Usuário são de sua exclusiva
              responsabilidade, sendo vedada qualquer alegação posterior de
              desconhecimento dos riscos envolvidos.
            </p>
            <p>
              Caso o Usuário alegue a existência de relação de consumo, caberá
              exclusivamente a ele comprovar tal caracterização, sem prejuízo da
              prevalência dos presentes Termos e Condições no que não conflitar
              com normas imperativas aplicáveis.
            </p>
            <p>
              23.7.2. O Usuário declara estar ciente que a Plataforma Tutu opera
              como ambiente de aproximação entre investidores e tomadores de
              recursos para fins de investimento empresarial, não se confundindo
              com fornecimento de produtos ou serviços de consumo. O Usuário
              declara, ainda, utilizar a Plataforma exclusivamente para fins de
              sua atividade econômica, seja como fonte de captação de recursos
              para seu negócio (Tomador) ou como alternativa de investimento de
              seus recursos financeiros (Investidor).
            </p>
            <p>
              23.8. Estes Termos são regidos pelas leis da República Federativa
              do Brasil.
            </p>
            <p class="title">24. ASSINATURA ELETRONICA</p>
            <p>
              24.1. Os Usuários admitem como válidas as assinaturas eletrônicas
              por elas realizadas no Contrato de Empréstimo e em qualquer outro
              termo, contrato ou documento vinculado à Tutu e à Plataforma Tutu,
              nos termos do artigo 10, §2º, da Medida Provisória n.º 2.200-2, de
              24 de agosto de 2001, sendo tais documentos dotados de certeza,
              liquidez e exigibilidade (título executivo extrajudicial),
              independentemente da assinatura de testemunhas.
            </p>
            <p class="title">
              25. RESPONSABILIDADE, RESOLUÇÃO DE CONFLITOS E FORO
            </p>
            <p>
              25.1. Fica eleito o Foro Central da Comarca de São Paulo, Estado
              de São Paulo, ressalvado à Tutu o direito de optar pelo foro de
              domicílio do Usuário para dirimir quaisquer questões oriundas
              destes Termos e Condições do Investidor e Tomador.
            </p>
            <p>
              25.2. Prazo Decadencial. O Usuário dispõe do prazo máximo e
              improrrogável de 90 (noventa) dias, contados da data em que
              identificou ou deveria ter identificado eventual irregularidade na
              Plataforma ou no Contrato de Empréstimo, para apresentar
              reclamação fundamentada à Tutu Digital, sob pena de decadência de
              seu direito. Após este prazo, o Usuário não poderá alegar
              desconhecimento ou pleitear qualquer tipo de compensação ou
              indenização.
            </p>
            <p>
              25.3. Limitação de Danos. Em qualquer hipótese de
              responsabilização da Tutu Digital, o Usuário expressamente
              renuncia ao direito de pleitear indenizações por danos indiretos,
              lucros cessantes, danos morais, danos à imagem ou quaisquer outras
              perdas que não constituam dano emergente diretamente causado por
              ação ou omissão exclusiva da Tutu Digital. O valor máximo de
              qualquer indenização a ser paga pela Tutu Digital será limitado ao
              montante das taxas efetivamente pagas pelo Usuário nos 12 (doze)
              meses anteriores ao evento danoso.
            </p>
            <p>
              25.4. A Tutu Digital não será responsável por prejuízos sofridos
              pelo Usuário em decorrência de eventos de caso fortuito ou força
              maior, entendidos como eventos imprevisíveis e inevitáveis cujos
              efeitos não puderam ser impedidos, incluindo, mas não se limitando
              a, pandemias, epidemias, desastres naturais, guerras, motins,
              ciberataques generalizados, alterações legislativas drásticas e
              outros eventos de natureza similar.
            </p>
            <p>
              25.5. O Usuário reconhece e aceita que a Tutu Digital não presta
              serviços de consultoria financeira, gestão de carteira, assessoria
              jurídica ou contábil, não sendo responsável pelas consequências
              fiscais, tributárias, contábeis ou legais das operações realizadas
              pelo Usuário por meio da Plataforma.
            </p>
            <p>
              25.6 Assim, sendo, o Usuário declara e concorda expressamente com
              o inteiro teor destes, ficando desde já obrigado e sujeito aos
              direitos e obrigações oriundos deste instrumento.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "terms-business-investor",
  methods: {
    close() {
      this.$emit("closeModal");
    }
  }
};
</script>

<style lang="sass" scoped>

.modal
  @apply fixed flex items-center justify-center z-50 w-screen h-screen top-0 left-0

.backdrop
  @apply fixed z-40 w-full h-full top-0 left-0
  background: rgba(29,26,26,.50)

.content
  @apply relative h-120 w-full bg-white z-50 flex flex-col pb-6 pt-8 rounded-lg
  @screen lg
    @apply w-11/12 h-160

.close
  @apply absolute right-0 top-0 text-secondary rounded-full p-1 m-1 cursor-pointer
  @screen lg
    @apply m-2 p-2 text-lg

.content_modal
  @apply flex flex-col w-full px-4 overflow-auto
  @screen lg
    @apply px-8

.row
  @apply w-full flex justify-center
  @screen md
    @apply justify-center mt-6

.title
  @apply text-xl text-primary font-bold mb-3

ul li
  @apply leading-normal mb-2 text-justify

p
  @apply leading-normal mb-2 text-justify

::-webkit-scrollbar
  @screen md
    width: 8px
  @screen lg
    width: 8px

::-webkit-scrollbar-track
  @screen md
    @apply bg-gray-400 rounded-lg
  @screen lg
    @apply bg-gray-400 rounded-lg

::-webkit-scrollbar-thumb
  @screen md
    @apply bg-gray-600 rounded-lg
    &:active
      @apply bg-secondary
  @screen lg
    @apply bg-gray-600 rounded-lg
    &:active
      @apply bg-secondary
</style>
